import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import * as Constants from './../../helpers/constants'
import UserlistPage from '../user_list_page'
import TrialPeriods from '../trial_periods'
import MiscellaneousApi from '../../component/miscellaneous'
import ClearoutIndividualUserInfo from '../individual_user_info/clearout_individual_user_info'
import ProductList from './../products/component/list'
import CreateProduct from './../products/component/create'
import OrganizationInfo from '../org_info/org_info'
import Coupons from '../coupons/coupons'
import OrgListPage from '../org_list_page'
import ManageAbuse from '../abuse/manage_abuse'
import UpdateHistory from '../update_history/abuse_update_history'
import AbuseLogs from '../abuse_view_logs/abuse_view_logs'
import UserActivities from '../user_activities/user_activities'
import ServiceLists from '../service_list'
import MembersList from '../members_list/members_list'
import ProspectRequests from '../clearout_prospect_requests/myRequests'
import GeneratePurchaseURL from './../products/component/generate_url'
import SearchByTags from '../search_by_tags'
import ProspectSearch from '../prospect_search'
import PlanInfo from '../product_info/plan_info_card'



const CLIENT = Constants.CLIENTS.CLEAROUT.NAME

const clearoutRouter = createBrowserRouter([
  {
    id: 'dashboard-clearout-route',
    path: CLIENT,
    children: [
      {
        id: 'dashboard-clearout-users',
        path: 'users',
        element: <UserlistPage />
      },
      {
        id: 'dashboard-clearout-search-by-tags',
        path: 'search_by_tags',
        element: <SearchByTags />
      },
      {
        id: 'dashboard-clearout-ev-list',
        path: 'email_verifier_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.EMAIL_VERIFIER} />
      },
      {
        id: 'dashboard-clearout-ef-list',
        path: 'email_finder_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.EMAIL_FINDER} />
      },
      {
        id: 'dashboard-clearout-prospect-list',
        path: 'prospect_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.PROSPECT} />
      },
      {
        id: 'dashboard-clearout-org-members-list',
        path: 'org_members_list',
        element: <MembersList />
      },
      {
        id: 'dashboard-clearout-miscellaneous-api',
        path: 'miscellaneous_api',
        element: <MiscellaneousApi />
      },
      {
        id: 'clearout-individual-user-info',
        path: 'individual_user_info',
        element: <ClearoutIndividualUserInfo />
      },
      {
        id: 'clearout-plan-list',
        path: 'plan_list',
        element: <ProductList />
      },
      {
        id: 'clearout-create-plan',
        path: 'create_plan',
        element: <CreateProduct />
      },
      {
        id: 'clearout-organization-info',
        path: 'organization_info',
        element: <OrganizationInfo />
      },
      {
        id: 'coupons',
        path: 'coupons',
        element: <Coupons />
      },
      {
        id: 'coupon',
        path: 'coupons/:couponId',
        element: <Coupons />
      },
      {
        id: 'dashboard-clearout-manage-abuse',
        path: 'abuse_list',
        element: <ManageAbuse />
      },
      {
        id: 'dashboard-clearout-view-logs',
        path: 'abuse_logs',
        element: <AbuseLogs />
      },
      {
        id: 'dashboard-clearout-update-logs',
        path: 'abuse_update_logs',
        element: <UpdateHistory />
      },
      {
        id: 'dashboard-clearout-org-users',
        path: 'org_list',
        element: <OrgListPage />
      },
      {
        id: 'dashboard-user-activities',
        path: 'individual_user_activity',
        element: <UserActivities />
      },
      {
        id: 'dashboard-prospect-requests',
        path: 'clearout_prospect/requests',
        element: <ProspectRequests />
      },

      {
        id: 'clearout-generate-purchase-url',
        path: 'generate_purchase_url',
        element: <GeneratePurchaseURL />
      },
      {
        id: 'dashboard-prospect-search',
        path: 'clearout_prospect/search',
        element: < ProspectSearch />
      },
      {
        id: 'clearout-plan-info',
        path: 'plan_info/:planId',
        element: <PlanInfo/>
      },
      {
        id: CLIENT + '-trial-periods',
        path: 'trial_periods',
        element: <TrialPeriods />
      },
      {
        id: CLIENT + '-redirect',
        path: '*',
        element:
          <Navigate
            to={'users'}
            replace={true}
          />
      },
    ]
  }
])

export default clearoutRouter
